import BaseController from "./base_controller"

// Notification Controller for Toast Messages
// Handles auto-dismiss functionality and manual dismissal with toast animations
export default class extends BaseController {
  static values = {
    autoDismiss: { type: Number, default: 5000 } // Auto-dismiss time in milliseconds
  }

  declare autoDismissValue: number
  private timeout: ReturnType<typeof setTimeout> | null = null

  connect(): void {
    super.connect()
    this.startAutoDismiss()
  }

  disconnect(): void {
    super.disconnect()
    this.clearTimeoutTimer()
  }

  dismiss(): void {
    this.clearTimeoutTimer()
    this.element.classList.add("toast-dismiss")

    // Remove from DOM after transition
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.remove()
      }
    }, 250)
  }

  private startAutoDismiss(): void {
    if (this.autoDismissValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.autoDismissValue)
    }
  }

  private clearTimeoutTimer(): void {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}

